import { Suspense } from 'react';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import BlogDetailHero from '../components/BlogDetailHero';
import BlogDetailContent from '../components/BlogDetailContent';
import { useSEO } from '../../../utils/seo';

const DigitalAdsBlog = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  useSEO({
    title: 'Dijital Reklamcılıkta Başarı İçin 5 Altın Kural - Sigorta360 Blog',
    description: 'Sigorta acenteleri için dijital reklamcılık başarı rehberi. Hedef kitle belirleme, bütçe yönetimi, A/B testleri ve remarketing stratejileri.',
    keywords: 'dijital reklamcılık, google ads, facebook ads, reklam stratejisi, sigorta reklamları',
    canonical: `${siteUrl}/akademi/dijital-reklamcilikta-basari-icin-5-altin-kural`,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'BlogPosting',
      headline: 'Dijital Reklamcılıkta Başarı İçin 5 Altın Kural',
      description: 'Sigorta acenteleri için dijital reklamcılık başarı stratejileri',
      author: {
        '@type': 'Organization',
        name: 'Sigorta360 Ekibi'
      },
      publisher: {
        '@type': 'Organization',
        name: 'Sigorta360',
        logo: {
          '@type': 'ImageObject',
          url: `${siteUrl}/logo.png`
        }
      },
      datePublished: '2025-01-10',
      dateModified: '2025-01-10',
      mainEntityOfPage: {
        '@type': 'WebPage',
        '@id': `${siteUrl}/akademi/dijital-reklamcilikta-basari-icin-5-altin-kural`
      }
    }
  });

  const blogData = {
    title: 'Dijital Reklamcılıkta Başarı İçin 5 Altın Kural',
    category: 'Dijital Reklamcılık',
    date: '10 Ocak 2025',
    readTime: '6 dk',
    author: 'Sigorota360 Ekibi',
    image: 'https://public.readdy.ai/ai/img_res/0346aebcff8fa308e18b1df1d6e66209.jpg',
    content: [
      {
        type: 'paragraph',
        text: 'Dijital reklamcılık, sigorta acenteleri için en hızlı müşteri kazanma yöntemlerinden biridir. Ancak başarılı olmak için doğru stratejileri uygulamak şarttır. İşte dijital reklamcılıkta başarı için 5 altın kural:',
      },
      {
        type: 'heading',
        text: '1. Hedef Kitlenizi Net Tanımlayın',
      },
      {
        type: 'paragraph',
        text: 'Başarılı bir reklam kampanyasının temeli, doğru hedef kitleye ulaşmaktır. Yaş, cinsiyet, konum, gelir seviyesi, ilgi alanları gibi demografik ve psikografik özellikleri detaylı şekilde belirleyin. Meta ve Google reklamları, çok detaylı hedefleme seçenekleri sunar.',
      },
      {
        type: 'heading',
        text: '2. Bütçenizi Akıllıca Yönetin',
      },
      {
        type: 'paragraph',
        text: 'Küçük bütçelerle başlayıp test edin. Hangi reklamlar daha iyi performans gösteriyor? Hangi hedef kitle daha fazla dönüşüm sağlıyor? Bu verilere göre bütçenizi optimize edin. Başlangıçta günlük 50-100 TL gibi küçük bütçelerle test yapabilirsiniz.',
      },
      {
        type: 'heading',
        text: '3. Görsellere Önem Verin',
      },
      {
        type: 'paragraph',
        text: 'Dijital reklamlarda görsel kalitesi çok önemlidir. Profesyonel, dikkat çekici ve mesajınızı net ileten görseller kullanın. Video reklamlar, statik görsellere göre genellikle daha yüksek etkileşim alır. Kısa, öz ve etkileyici videolar hazırlayın.',
      },
      {
        type: 'heading',
        text: '4. A/B Testleri Yapın',
      },
      {
        type: 'paragraph',
        text: 'Farklı reklam metinleri, görseller ve hedef kitleler ile A/B testleri yapın. Hangi kombinasyon daha iyi sonuç veriyor? Sürekli test ederek kampanyalarınızı optimize edin. Başlık, açıklama, görsel ve CTA butonlarını test edin.',
      },
      {
        type: 'heading',
        text: '5. Remarketing Kullanın',
      },
      {
        type: 'paragraph',
        text: 'Web sitenizi ziyaret eden ancak dönüşüm gerçekleştirmeyen kullanıcılara remarketing reklamları gösterin. Bu kullanıcılar markanızı zaten tanıyor, bu yüzden dönüşüm oranları çok daha yüksek olur. Remarketing, en yüksek ROI sağlayan reklam türlerinden biridir.',
      },
      {
        type: 'paragraph',
        text: 'Bu 5 altın kuralı uygulayarak dijital reklam kampanyalarınızdan maksimum verim alabilir, bütçenizi en etkili şekilde kullanabilirsiniz. Unutmayın, dijital reklamcılık sürekli öğrenme ve optimizasyon gerektirir.',
      },
    ],
  };

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <div className="min-h-screen bg-white">
        <Header />
        <BlogDetailHero data={blogData} />
        <BlogDetailContent data={blogData} />
        <Footer />
      </div>
    </Suspense>
  );
};

export default DigitalAdsBlog;
